module.exports = "/_next/static/images/topImg-9c1ac652f7b881725d6e15efeae1159b.png";